import { render, staticRenderFns } from "./SpecialismTabButton.vue?vue&type=template&id=c54f24a2&"
import script from "./SpecialismTabButton.vue?vue&type=script&lang=js&"
export * from "./SpecialismTabButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports